import { IconButton, Tooltip } from '@mui/material';
import ContentCopy from '@mui/icons-material/ContentCopy';
import CopyToClipboard from 'react-copy-to-clipboard';

interface CopyToClipboardButtonProps {
  textToCopy: string;
}

export const CopyToClipboardButton = ({ textToCopy }: CopyToClipboardButtonProps) => (
  <Tooltip title="Copy to Clipboard" arrow>
    <div>
      <CopyToClipboard text={textToCopy}>
        <IconButton size="small">
          <ContentCopy />
        </IconButton>
      </CopyToClipboard>
    </div>
  </Tooltip>
);
